const constants = {
  chartType: {
    line: 'line',
    histogram: 'histogram',
    bar: 'bar',
    point: 'point'
  },
  axisOrientation: {
    top: 'top',
    bottom: 'bottom',
    left: 'left',
    right: 'right'
  },
  scaleType: {
    categorical: 'categorical',
    linear: 'linear',
    log: 'log'
  },
  axisFormat: {
    date: 'date',
    number: 'number',
    percentage: 'percentage'
  },
  legendObject: {
    circle: 'circle',
    line: 'line',
    square: 'square'
  },
  symbol: {
    line: '—',
    circle: '•',
    square: '■'
  },
  orientation: {
    vertical: 'vertical',
    horizontal: 'horizontal'
  },
  defaultColors: [
    '#1f77b4',
    '#ff7f0e',
    '#2ca02c',
    '#d62728',
    '#9467bd',
    '#8c564b',
    '#e377c2',
    '#7f7f7f',
    '#bcbd22',
    '#17becf'
  ]
}

export default constants
